import { createModule } from "saga-slice";
import { call, put} from "redux-saga/effects";
import { changePassword, loginUser, signupUser, updateCompanyInfoApi, updateReceiptLanguage } from "../services/authService";
import { compact } from "lodash";

const authModule = createModule({
  name: "auth",
  initialState: {
    isLoading: false,
    isAuthenticated: false,
    accessToken: null,
    refreshToken: null,
    fullName: null,
    commercialId: null,
    pointOfSaleId: null,
    role: null,
    businessName: null,
    address:null,
    telephone:null,
    email:null,
    error: null,
    logoutMessage: null,
    signupSuccessMessage: null,
    receiptLanguage:null,
    company:null
  },
  reducers: {
    loginRequest: (state) => {
      state.isLoading = true;
      state.error = null;
      state.logoutMessage = null;
    },
    loginSuccess: (state, payload) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
      state.fullName = payload.fullName;
      state.commercialId = payload.commercialId;
      state.pointOfSaleId = payload.pointOfSaleId;
      state.role = payload.role;
      state.businessName = payload.businessName;
      state.address = payload.address;
      state.telephone = payload.telephone;
      state.email = payload.email;
      state.receiptLanguage = payload.receiptLanguage;
      state.company = payload.company;

    },
    updateReceiptLanguageSuccess: (state, payload) => {
      state.isLoading = false;
      state.receiptLanguage = payload.receiptLanguage;
    },
    changePassword: (state) => {
      state.isLoading = true;
      state.error = null;
      state.logoutMessage = null;
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.fullName = null;
      state.role = null;
      state.commercialId = null;
      state.pointOfSaleId = null;
      state.businessName = null;
      state.error = action;
      state.address = null;
      state.telephone = null;
      state.email = null;
      state.receiptLanguage = null;
      state.company = null;
    },
    signupRequest: (state) => {
      state.isLoading = true;
      state.error = null;
      state.signupSuccessMessage = null;
    },
    updateCompanyInfo: (state) => {
      state.isLoading = true;
      state.error = null;
      state.signupSuccessMessage = null;
    },
    updateCompanyInfoSuccess: (state, payload) => {
      state.isLoading = false;
      state.company = payload.company;
    },
    signupSuccess: (state, payload) => {
      state.isLoading = false;
      state.signupSuccessMessage = payload.message;
    },
    signupFailure: (state, action) => {
      state.isLoading = false;
      state.error = action;
    },
    finishLoading: (state) => {
      state.isLoading = false;
    }, 
    logout: (state) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.commercialId = null;
      state.pointOfSaleId = null;
      state.fullName = null;
      state.role = null;
      state.businessName = null;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      state.logoutMessage = "You have been logged out successfully.";
    },
  },
  sagas: (A) => ({
    *[A.loginRequest]({ payload }) {
      try {
        const {data} = yield call(loginUser, payload.user);

        const { accessToken, refreshToken, fullName, role, commercialId, pointOfSaleId, businessName, address, telephone, email, receiptLanguage, company } = data;
        yield put(A.loginSuccess({ accessToken, refreshToken, fullName, role, commercialId, pointOfSaleId, businessName ,address, telephone, email, receiptLanguage,company}));
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        yield call(payload.onSuccess, data); // Navigate to the admin dashboard
      } catch (error) {
        yield put(A.loginFailure(error.message || "Something went wrong"));
        if (payload.onError) {
          yield call(payload.onError);
        }
      }
    },
    *[A.updateCompanyInfo]({ payload }) {
      try {
        const data = yield call(updateCompanyInfoApi, payload.companyInfo);

        yield put(A.updateCompanyInfoSuccess({ company: data}));
        yield call(payload.onSuccess); // Navigate to the admin dashboard
      } catch (error) {
        yield put(A.loginFailure(error.message || "Something went wrong"));
        if (payload.onError) {
          yield call(payload.onError);
        }
      }
    },
    *[A.signupRequest]({ payload }) {
      try {
        const response = yield call(signupUser, payload.userData);
        yield put(A.signupSuccess({ message: response.message }));

        // Navigate to login page after successful signup
        payload.navigate("/login");
      } catch (error) {
        yield put(A.signupFailure(error.message || "Signup failed. Please try again."));
      }
    },
    *[A.changePassword]({ payload }) {
      try {
        // Call the API to change the password
        yield call(changePassword, payload.form);
        yield put(A.finishLoading());
        yield call(payload.onSuccess); // Navigate to the admin dashboard
      } catch (error) {
        yield put(A.finishLoading());
        if (payload.onError) {
          yield call(payload.onError);
        }
      }
    }
  }),

});

export default authModule;
export const authActions = authModule.actions;
